import { render, staticRenderFns } from "./ChipStatus.vue?vue&type=template&id=0223fcde"
import script from "./ChipStatus.vue?vue&type=script&lang=js"
export * from "./ChipStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports